module.exports = __webpack_public_path__ + "static/organic-search-row-eight-hero-b21593107708eeff093341f8150a5262.png";